export default __webpack_public_path__ + "static/media/misc-closetA-1024w.9f32a95a.png";